<script lang="ts">export let progress = 0;
export let height = "8px";
</script>

<div class="progress-container">
	<div class="progress-bar" style="height: {height}">
		<div class="progress-fill" style="width: {progress}%"></div>
	</div>
</div>

<style>
	.progress-container {
		display: flex;
		align-items: center
}

	.progress-bar {
		position: relative;
		width: 100%;
		border-radius: 0.5rem;
		background-color: var(--component-progress-background);
		flex-grow: 1
}

	.progress-fill {
		position: relative;
		height: 100%;
		border-radius: 0.5rem;
		background: var(--component-progress-fill);
		box-shadow: 0px 0px 5px 1px
			var(--component-progress-fill-shadow, var(--component-progress-fill))
}
</style>
